import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReservationStatus } from '@r6digital/rapidstor-types/types/Reservation';

import Button from '@/core/components/elements/button';

import classes from './styles.module.scss';

interface Props {
    status: ReservationStatus;
    onGoBack: () => void;
}

/**
 * Shown in place of a payment form when SiteLink reports the reservation as cancelled
 * or expired. The wizards render this on page load, so the customer never fills in a
 * form for a reservation that cannot take the payment.
 *
 * Cancelled and expired get different copy on purpose. A cancelled reservation needs
 * the facility; an expired one the customer can book again themselves.
 */
export default function ReservationUnavailable({ status, onGoBack }: Props) {
    const { t } = useTranslation();

    return (
        <div id="reservation-unavailable" className={classes.container}>
            <span className={classes.header}>
                {status.cancelled
                    ? t('error:reservation_cancelled_title')
                    : t('error:reservation_expired_title')}
            </span>
            <p className={classes.message}>
                {status.cancelled
                    ? t('error:reservation_cancelled')
                    : t('error:reservation_expired')}
            </p>
            <Button onclick={onGoBack} type="primary" size="medium">
                {t('error:go_back')}
            </Button>
        </div>
    );
}
